/**
 * iurop-reviews.js — Apodemia
 * - Baraja el pool de reseñas y muestra N (data-visible) para que "cambien" en
 *   cada carga.
 * - Clic en una card → modal con imagen, reseña completa y fuente.
 * Cierre con X / overlay / Esc. Re-init en el editor de temas.
 */
(function () {
  'use strict';

  function shuffleInPlace(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function initSection(section) {
    var row = section.querySelector('[data-reviews-row]');
    var modal = section.querySelector('[data-reviews-modal]');
    if (!row || !modal) return;

    var cards = Array.prototype.slice.call(row.querySelectorAll('[data-review]'));
    var visible = parseInt(section.getAttribute('data-visible'), 10) || 4;
    var doShuffle = section.getAttribute('data-shuffle') === 'true';

    if (doShuffle) {
      shuffleInPlace(cards);
      cards.forEach(function (c) {
        row.appendChild(c); // reordena el DOM según el barajado
      });
    }

    cards.forEach(function (c, idx) {
      c.style.display = idx < visible ? '' : 'none';
    });

    // --- Modal ---
    var html = document.documentElement;
    var img = modal.querySelector('[data-modal-image]');
    var mediaWrap = modal.querySelector('[data-modal-media]');
    var starsEl = modal.querySelector('[data-modal-stars]');
    var textEl = modal.querySelector('[data-modal-text]');
    var nameEl = modal.querySelector('[data-modal-name]');
    var sourceEl = modal.querySelector('[data-modal-source]');

    function open(card) {
      var imgUrl = card.getAttribute('data-image') || '';
      if (imgUrl && img && mediaWrap) {
        img.src = imgUrl;
        img.alt = card.getAttribute('data-name') || '';
        mediaWrap.hidden = false;
      } else if (mediaWrap) {
        mediaWrap.hidden = true;
      }
      var cardStars = card.querySelector('.apodemia-reviews__stars');
      if (starsEl) starsEl.innerHTML = cardStars ? cardStars.innerHTML : '';
      if (textEl) textEl.textContent = card.getAttribute('data-text') || '';
      if (nameEl) nameEl.textContent = card.getAttribute('data-name') || '';

      if (sourceEl) {
        var label = card.getAttribute('data-source-label') || '';
        var url = card.getAttribute('data-source-url') || '';
        var srcType = card.getAttribute('data-source') || '';
        sourceEl.setAttribute('data-source', srcType);
        if (url) {
          var a = document.createElement('a');
          a.href = url;
          a.target = '_blank';
          a.rel = 'noopener';
          a.textContent = label;
          sourceEl.innerHTML = '';
          sourceEl.appendChild(a);
        } else {
          sourceEl.textContent = label;
        }
      }

      modal.hidden = false;
      html.classList.add('apodemia-reviews-open');
    }

    function close() {
      modal.hidden = true;
      html.classList.remove('apodemia-reviews-open');
    }

    row.addEventListener('click', function (e) {
      var card = e.target.closest('[data-review]');
      if (card) open(card);
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-review-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-reviews-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-reviews-section]');
    if (section) initSection(section);
  });
})();
